<template>
    <div class="button-list">
        <div
                v-for="(button,index) in buttons"
                :key="index"
                class="btn-list-item"
        >
            <v-btn
                    large round block
                    color="primary"
                    @click="selectButton(index)"
                    class="btn-border"
                    :outline="index === selectedButtonIndex? false: true"
            >
                {{button.title ? button.title : 'Unnamed Button'}}
            </v-btn>
            <v-btn class="delete-button" @click="deleteButton(index)" v-if="index > 0" fab small color=""><v-icon small color="#666">delete_outline</v-icon></v-btn>
        </div>

        <v-btn
                large round flat block
                class="primary--text"
                @click="addButton"
        >
            <v-icon>add_circle_outline</v-icon>
            Add Button
        </v-btn>
        <div class="selected-button" v-if="buttons.length">
            <v-form
                    ref="form"
                    v-model="valid"
            >
                <label>Button Title</label>
<!--                <v-text-field-->
<!--                        v-model="buttons[selectedButtonIndex].title"-->
<!--                        :rules="[v => !!v || 'Button Title is Required']"-->
<!--                        outline-->
<!--                >-->
<!--                </v-text-field>-->
                <vTextareaAutocomplete
                  v-model="buttons[selectedButtonIndex].title"
                  :validation-rules="autocompleteButtonTitleValidationRules"
                  :class="{'validation-warning': buttons[selectedButtonIndex].title.length>20}"
                  :counter = "20"
                  type="textfield"
                  solo></vTextareaAutocomplete>
                <label>Enter Block</label>
                <v-autocomplete
                        :items="blocksList"
                        item-text="name"
                        item-value="id"
                        v-model="buttons[selectedButtonIndex].block_id"
                        :rules="[v => !!v || 'Block is Required']"
                        outline
                        solo
                >

                </v-autocomplete>
            </v-form>
        </div>
    </div>
</template>

<script>
    import _ from "lodash";
    import common from '../../../../../utils/common'
    export default {
        name: "button-list-blocks",
        props: {
            buttons: {
                type: Array,
                default: ()=> {
                    return []
                }
            },
            blocksList: {
                type: Array,
                default: ()=> {
                    return []
                }
            }
        },
        data() {
            return {
                selectedButton: {
                    block_id: '',
                    errorOrEmpty: '',
                    phone: '',
                    title: '',
                    type: '',
                    url: ''
                },
                selectedButtonIndex: 0,
                activeTab: 0,
                valid: true,
                common,
                types: [
                    {
                        position: 0,
                        name:'block'
                    },
                    {
                        position: 1,
                        name: 'url'
                    },
                    {
                        position: 2,
                        name: 'phone'
                    }
                ],
                autocompleteButtonTitleValidationRules: [
                    v => !!v || 'Button Title Title is Required',
                    v => v.length < 20 || 'Button text can\'t be more than 20 characters if you are supporting Facebook'
                ],
            }
        },
        mounted(){

            this.getActiveTab()
            if (this.buttons.length) {
                this.buttons[this.selectedButtonIndex].block_id = parseInt(this.buttons[this.selectedButtonIndex].block_id)
                this.$refs.form.validate()
            }
        },
        methods: {
            selectButton(index) {
                this.selectedButtonIndex = index
            },
            addButton() {
                const newButton = {
                    block_id: '',
                    errorOrEmpty: '',
                    phone: '',
                    title: `Untitled Button`,
                    type: 'block',
                    url: ''
                }
                this.buttons.push(newButton)
                this.selectedButtonIndex = this.buttons.length -1
                this.activeTab = 0
                if (this.$refs.form){
                    this.$refs.form.validate()
                }
            },
            deleteButton(index) {
                if (this.selectedButtonIndex === index) {
                    this.selectedButtonIndex = 0
                }
                this.buttons.splice(index, 1)
                this.activeTab = 0
                if (this.$refs.form){
                    this.$refs.form.validate()
                }
            },
            getActiveTab() {
                if (this.buttons.length) {
                    let index = _.findIndex(this.types, o => {
                        return o.name === this.buttons[this.selectedButtonIndex].type
                    })
                    if (index !== -1) {
                        this.activeTab = this.types[index].position
                    }
                }
            },
            changeTab() {
                let index = _.findIndex(this.types, o=>{
                    return this.activeTab === o.position
                })
                this.buttons[this.selectedButtonIndex].type = this.types[index].name
            }
        },
        watch:{
            selectedButtonIndex() {
                this.buttons[this.selectedButtonIndex].block_id = parseInt(this.buttons[this.selectedButtonIndex].block_id)
                this.getActiveTab()
            },
        }
    }
</script>

<style >
.validation-warning .error--text{
    color: orange !important;
}
</style>
